module.exports = __webpack_public_path__ + "static/media/intro-animation2.ce37b618.png";